import { FormBuilder, FormControl } from '@angular/forms';
import { CalendarTranslateService } from './../../services/calendarTranslate.service';
import { Component, Input, OnInit, Output, EventEmitter, ViewChildren, AfterViewInit, QueryList, SimpleChanges, OnChanges, AfterContentChecked } from '@angular/core';
import { QueryBuilderConfig } from 'angular2-query-builder';
import * as moment from 'moment';
import { Calendar } from 'primeng/primeng';

@Component({
  selector: 'rules-query-builder',
  templateUrl: './rules-query-builder.component.html',
  styleUrls: ['./rules-query-builder.component.css']
})
export class RulesQueryBuilder implements OnInit,AfterContentChecked {
  ctrl: FormControl;
  submitted = false;
  @Input() query: any;
  @Input() config: QueryBuilderConfig;
  @Input() showSendQueryBtn = true;
  @Input() openedAccordion = false;
  @Output() extSearchReq: EventEmitter<any> = new EventEmitter();
 

  constructor(
    public srvCalendarTranslate: CalendarTranslateService,
    private fb: FormBuilder
  ) {
    this.ctrl = this.fb.control(this.query);
  }

  ngOnInit() {
    const validator = (rule) => {
      if (!rule.value) {
        return {
          rule: rule,
          message: 'Campo obbligatorio'
        }
      }
    };
    for (const field in this.config.fields) {
      Object.assign(this.config.fields[field], {validator});
      if (this.config.fields[field].type === 'date') {
        Object.assign(this.config.fields[field], {dateValue: ''});
      }
    }

  }
  resetModelDate() {

    if (this.query && this.query.rules) {
      this.query.rules.forEach(rule => {
        let type = rule.field?this.config.fields[rule.field].type:"";
        if(type == "date" || type == "number"){
          rule.datevalue = null;
          rule.startValue = null;
          rule.endValue = null;
        }

        if (rule.operator === 'between' && !Array.isArray(rule.value)) {
          rule.value = [null, null];
        }

      });
    }
  }
  ngAfterContentChecked(): void {
    this.resetModelDate();
  }
  convertDate(rule,ref,type) {
    //modificata perchè non sbiancava il valore delle date, cambiato anche nell'html l'ngModel, con singolo binding
    let valueDate = ref.value;
    if(type=="dateValue"){
      rule.value = moment(valueDate).format('YYYY-MM-DD');
    }
    else if(type=="startValue" || type=="endValue"){

      if (rule.operator === 'between') {
        if(!rule.value){
         rule.value = [null,null];
        }

        if(type=="startValue" && rule.value){
          rule.value[0] = moment(valueDate).format('YYYY-MM-DD');
        }
        else if(type=="endValue"){
          rule.value[1] = moment(valueDate).format('YYYY-MM-DD');
        }
      }
    }

  }
  convertNumber(rule,ref,type)  {

    let valueNumber = ref.value;

    if (rule.operator === 'between') {
      if(!rule.value){
       rule.value = [null,null];
      }

      if(type=="startValue"){
        rule.value[0] = valueNumber;
      }
      else if(type=="endValue"){
        rule.value[1] = valueNumber;
      }
    }

  }
  sendQuery() {
    this.submitted = true;
    this.ctrl.updateValueAndValidity();
    if (this.ctrl.valid) {
      this.extSearchReq.emit(this.query);
    }
  }
  public controlOperator(operator: string) {
    if(operator === 'exists' || operator === 'not exists' || operator === 'esiste' || operator === 'non esiste') {
      return false;
    } else {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/rules-query-builder/rules-query-builder.component.ts